import { Paso } from './Paso';

export class PasoCooler extends Paso {
  constructor() {
    super(
      true,
      'Cooler',
      'El cooler mantiene la temperatura de tu equipo, evitando el daño en los componentes y permitiendo que este funcione correctamente.',
      3,
      'cooler.png',
      'cooler.png',
      false,
      [],
      '',
    );
  }
}
